






import { defineComponent, ref } from '@vue/composition-api';
import { useActions } from 'vuex-composition-helpers';

export default defineComponent({
  setup(props, { emit }) {
    const { deleteCompany } = useActions(['deleteCompany']);
    const deleting = ref<boolean>(false);

    return {
      deleting,
      deleteCompany: async (companyId: string) => {
        deleting.value = true;
        await deleteCompany(companyId);
        deleting.value = false;

        emit('deleted');
      },
    };
  },
});
